<!-- Use defer to prevent the navigation box being visible before redirecting to Google Map on user location GPS mode -->
@defer (on timer(100)) {
<div class="px-10 py-4 w-[80%] ml-[10%] bg-[#ffffffe0] rounded-lg border-2 border-blue-400 flex gap-5
  justify-center items-center shadow-md mobile:w-[90%] mobile:ml-[5%] mobile:px-3"
  [class.!bg-[#000000bf]]="mode==='dark'">
  <mat-icon class="text-[40px] leading-10 !w-10 !h-10 cursor-pointer text-gray-500"
    [class.!cursor-not-allowed]="noMorePrevious" (click)="previous()"
    [class.!text-gray-200]="mode==='dark'">{{noMorePrevious ? '' : 'chevron_left'}}</mat-icon>
  <div class="w-[80%] flex flex-col gap-2 items-center justify-center text-gray-500"
    [class.!text-gray-300]="mode==='dark'">
    <div [innerHtml]="direction" class="text-center"></div>
    <p>{{time}}</p>
    <p>{{distance}}</p>
    <div class="cursor-pointer rounded-sm text-blue-400 underline py-2 px-8" (click)="exit()">
      Exit Navigation</div>
  </div>
  <mat-icon class="text-[40px] leading-10 !w-10 !h-10 cursor-pointer text-gray-500"
    [class.!cursor-not-allowed]="noMoreNext" [class.!text-gray-200]="mode==='dark'" (click)="next()">{{noMoreNext ? '' :
    'chevron_right'}}</mat-icon>
</div>
}
